export const getUniqueApplications = (redirector) => {
    return redirector?.flatMap((item) => item.application_percentages)
        .map((app) => ({ name: app.application.name, icon: app.application.icon }))
        .reduce((acc, current) => {
            if (!acc.some((item) => item.name === current.name)) {
                acc.push(current);
            }
            return acc;
        }, []) || [];
};
